import { post } from '@/helpers/http';

const BASE_PATH = 'auth';

export function login(email, password) {
  return post(`${BASE_PATH}/login`, { email, password });
}

export function register(registerInfo) {
  return post(`${BASE_PATH}/register`, registerInfo);
}

export function sendNewPassword(email) {
  return post('user/mail', email);
}
